module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-farbe-beispiel-roh.4d94233a.jpeg";